/* eslint-disable max-len */
import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_PRODUCTS = gql`
query Get($slugName: String, $productGroup: String, $productType: String, $deleted: Boolean, $from: Int, $to: Int, $sortingField: String, $sortingType: Int) {
  getProductsWithTotal(slugName: $slugName, productGroup: $productGroup, productType: $productType, deleted: $deleted, from: $from, to: $to, sortingField: $sortingField, sortingType: $sortingType) {
    isAuth
    total
    query
    products {
      _id
      slugName
      productGroup
      subscriptionLength
      subscriptionDays
      title{ca en es}
      description{ca en es}
      amount
      currency
      productType
      productPresent
      createdAt
      deletedAt
    }
  }
}
`;

const getProductsWithTotal = async (variables) => {
  try {
    const result = await client.query({
      query: GET_PRODUCTS,
      variables,
      errorPolicy: 'all',
      fetchResults: true,
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { getProductsWithTotal: productsData } } = result;

    if (productsData) {
      return productsData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getProducts = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getProducts Error: ${error}`);
    return null;
  }
};

export default getProductsWithTotal;
